import styled from 'styled-components';

export const AssignCountryWrapper: any = styled.div`

.pageTitleSection{
    position: relative;
    left: -30px;
}

`


// WEBPACK FOOTER //
// ./src/styles/assigncountry.tsx